import { render, staticRenderFns } from "./molecule.swatch.tab.vue?vue&type=template&id=2a65537e"
import script from "./molecule.swatch.tab.vue?vue&type=script&lang=ts"
export * from "./molecule.swatch.tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports